// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__10mT3","image":"App_image__3yZYl","btn":"App_btn__R4zs7"};